import sentryInterceptor from './sentryInterceptor';
import listOflistsInterceptor from './listOflistsInterceptor';
import discoveryKPIInterceptor from './discoveryKPIInterceptor';
import shortFormVideoKPIInterceptor from './shortFormVideoKPIInterceptor';
import positionsTableCustomersInterceptor from './positionsTableCustomersInterceptor';
import positionsTableInterceptor from './positionsTableInterceptor';
import shazamTagInterceptor from './shazamTagInterceptor';
import chartsInterceptor from './chartsInterceptor';
import chartsTableDataInterceptor from './chartsTableDataInterceptor';
import shortFormVideoTerritoryInterceptor from './shortFormVideoTerritoryInterceptor';
import shortFormVideoTopTracksInterceptor from './shortFormVideoTopTracksInterceptor';
import playlistKPIInterceptor from './playlistKPIInterceptor';
import chartExpandedTrendInterceptor from './chartExpandedTrendInterceptor';
import recentListMetadataInterceptor from './recentListMetadata';
import shortFormVideoTrendInterceptor from './shortFormVideoTrendInterceptor';
import shortFormVideoBreakdownInterceptor from './shortFormVideoBreakdownInterceptor';
import audienceTrendInterceptor from './audienceTrendInterceptor';
import topChartsInterceptor from './topchartsInterceptor';
import certificationInterceptor from './certificationsInterceptor';
import topPerformingArtistsOnSocial from './topArtistsOnSocialInterceptor';
import topCertificationsInterceptor from './topCertificationsInterceptor';
import positionTrackerInterceptor from './positionTrackerInterceptor';
import linkfireActivityTrendInterceptor from './linkfireActivityTrendInterceptor';
import linkfireTableInterceptor from './linkfireTableInterceptor';
import entitiesInterceptor from './entitiesInterceptor';
import shortFormVideoActualityInterceptor from './shortFormVideoActualityInterceptor';

/**
 * A simple struct to look up interceptor functions that are associated
 * with a specific path element.
 * src/helpers/interceptConnect makes use of this registry to find its appropriate
 * interceptor functions.
 * Note: Please keep the path element names in lower case, since interceptConnect will force
 * the path element to lower case.
 */
const interceptorRegistry: {
  [key: string]: (
    input: RequestInfo,
    init: RequestInit | undefined,
    interceptionData?: any
  ) => Promise<Response>;
} = {
  chartexpandedtrend: chartExpandedTrendInterceptor,
  chartsdata: chartsInterceptor,
  topchartsdata: topChartsInterceptor,
  discoverykpi: discoveryKPIInterceptor,
  shortFormVideokpi: shortFormVideoKPIInterceptor,
  listoflists: listOflistsInterceptor,
  positionstablecustomers: positionsTableCustomersInterceptor,
  positionstable: positionsTableInterceptor,
  shazamtag: shazamTagInterceptor,
  chartstabledata: chartsTableDataInterceptor,
  shortFormVideoterritories: shortFormVideoTerritoryInterceptor,
  shortFormVideotracks: shortFormVideoTopTracksInterceptor,
  shortFormVideotrend: shortFormVideoTrendInterceptor,
  shortFormVideobreakdown: shortFormVideoBreakdownInterceptor,
  playlistkpi: playlistKPIInterceptor,
  recentlistmetadata: recentListMetadataInterceptor,
  audienceTrend: audienceTrendInterceptor,
  certification: certificationInterceptor,
  artistsOnSocial: topPerformingArtistsOnSocial,
  topCertifications: topCertificationsInterceptor,
  positiontracker: positionTrackerInterceptor,
  linkfireactivity: linkfireActivityTrendInterceptor,
  linkfiretable: linkfireTableInterceptor,
  entities: entitiesInterceptor,
  shortFormVideoActuality: shortFormVideoActualityInterceptor,
  // These are regular api calls that are only intercepted to serialize any errors to Sentry
  api: sentryInterceptor,
  notifications: sentryInterceptor,
  kv: sentryInterceptor,
};

export default interceptorRegistry;
